import { useEffect, useMemo, useState } from "react";
import { NotificationManager } from "react-notifications";
import { DetalleTurnoFinalizadoApi } from "../api/DetalleTurnoFinalizadoApi";
import { getErrorFromResponse } from "../../../../../../../../utility/utils";
import { PESO_KG_PACA_PRODUCCION } from "../../../../../../../../utility/constants";
import {
    agruparSobrantesPorPadrePT,
    combinarTotalesPadresConSobrantes,
} from "../../../helpers/sobrantesTurno";

export const useDetalleTurnoFinalizado = (turnoId) => {
    const [turno, setTurno] = useState({});
    const [totalesProduccion, setTotalesProduccion] = useState({});
    const [totalesPadresPT, setTotalesPadresPT] = useState([]);
    const [sobrantes, setSobrantes] = useState([]);
    const [pacasSecadora, setPacasSecadora] = useState(null);
    const [sobranteEnviadoBodega, setSobranteEnviadoBodega] = useState(false);

    const { getDetalleTurno, cargando } = DetalleTurnoFinalizadoApi();

    const GetDetalleTurno = async () => {
        try {
            const response = await getDetalleTurno(turnoId);

            setTurno(response.turno || {});
            setTotalesProduccion(response.totales_produccion || {});
            setTotalesPadresPT(response.totales_padres_pt || []);
            setSobrantes(response.sobrantes || []);
            setPacasSecadora(response.pacas_secadora || null);
            setSobranteEnviadoBodega(!!response.sobrante_enviado_bodega);
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al obtener el detalle del turno.",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
        }
    };

    useEffect(() => {
        if (turnoId) GetDetalleTurno();
    }, [turnoId]);

    const hayPacasEnSecadora = !!pacasSecadora;
    const haySobranteTurno = sobrantes.length > 0;

    const pesoPacasSecadora = hayPacasEnSecadora
        ? (pacasSecadora.cantidad || 0) * PESO_KG_PACA_PRODUCCION
        : 0;

    const pesoSobranteTurno = sobrantes.reduce(
        (sum, item) =>
            sum +
            (item.kg_secos_sobrantes_conforme || 0) +
            (item.kg_secos_sobrantes_no_conforme || 0),
        0,
    );

    const totalProduccionAproximada =
        (totalesProduccion.kg_pacas_paletizadas || 0) +
        pesoPacasSecadora +
        pesoSobranteTurno;

    // kg secos sobrantes guardados en el turno, agrupados por padre PT
    const sobrantesPorPadrePT = useMemo(
        () => agruparSobrantesPorPadrePT(sobrantes),
        [sobrantes],
    );

    // filas de la tabla de padres PT con los kg sobrantes sumados al total producido
    const totalesPadresPTConSobrantes = useMemo(
        () =>
            combinarTotalesPadresConSobrantes(
                totalesPadresPT,
                sobrantesPorPadrePT,
            ),
        [totalesPadresPT, sobrantesPorPadrePT],
    );

    const totalesProduccionConSobrantes = {
        ...totalesProduccion,
        kg_secos_sobrantes: pesoSobranteTurno,
        kg_producidos:
            (totalesProduccion.kg_producidos || 0) + pesoSobranteTurno,
    };

    return {
        turno,
        totalesProduccion,
        totalesPadresPTConSobrantes,
        totalesProduccionConSobrantes,
        sobrantes,
        pacasSecadora,
        sobranteEnviadoBodega,
        cargando,

        hayPacasEnSecadora,
        haySobranteTurno,
        pesoPacasSecadora,
        totalProduccionAproximada,
    };
};
